import React, { useState } from 'react';
import AuthPage from './components/AuthPage';
import GravelRouteTracker from './components/GravelRouteTracker';
import { getSession, clearSession } from './utils/auth';

export default function App() {
  const [currentUser, setCurrentUser] = useState(() => getSession());

  const handleLogin = (username) => {
    setCurrentUser(username);
  };

  const handleLogout = () => {
    clearSession();
    setCurrentUser(null);
  };

  if (!currentUser) {
    return <AuthPage onLogin={handleLogin} />;
  }

  return <GravelRouteTracker currentUser={currentUser} onLogout={handleLogout} />;
}